import ChangeDelivery from "./ChangeDelivery.vue";
import ChangeMail from "./ChangeMail.vue";
import ChangePassword from "./ChangePassword.vue";
import Index from "./Index.vue";
import Unregister from "./Unregister.vue";
import UnregisterReception from "./UnregisterReception.vue";
import UnregisterComplete from "./UnregisterComplete.vue";
import UnregisterCompleteEnd from "./UnregisterCompleteEnd.vue";

export default {
  routes: [
    {
      path: "/settings",
      component: Index,
    },
    {
      path: "/settings/mail",
      component: ChangeMail,
    },
    {
      path: "/settings/password",
      component: ChangePassword,
    },
    {
      path: "/settings/delivery",
      component: ChangeDelivery,
    },
    {
      path: "/settings/unregister",
      component: Unregister
    },
    {
      path: "/settings/unregister/reception",
      component: UnregisterReception
    },
    {
      path: "/settings/unregister/complete/:info&:achievement",
      component: UnregisterComplete
    },
    {
      path: "/settings/unregister/completeend",
      component: UnregisterCompleteEnd
    },
  ],
};
